import { features } from "@/lib/lottery-data";
import { cn } from "@/lib/utils";

interface FeaturesGridProps {
  activeFeature: number;
  onFeatureClick: (idx: number) => void;
}

const badgeClass = {
  free: "bg-lt-teal-bg text-lt-teal border border-lt-teal-border",
  pro: "bg-lt-gold-bg text-primary border border-lt-gold-border",
  premium: "bg-lt-purple-bg text-lt-purple border border-lt-purple-border",
};
const badgeLabel = { free: "Grátis", pro: "Pro", premium: "Premium" };

const FeaturesGrid = ({ activeFeature, onFeatureClick }: FeaturesGridProps) => {
  return (
    <div className="mx-auto max-w-[900px] px-8 pb-[72px]" id="funcionalidades">
      <div className="mb-3 text-[10px] font-medium uppercase tracking-[0.14em] text-primary">Funcionalidades</div>
      <h2 className="mb-3.5 font-serif text-[clamp(26px,3.5vw,46px)] font-light leading-[1.15] text-foreground">
        Ferramentas que <em className="text-primary italic">mudam o jogo</em>
      </h2>
      <p className="mb-9 max-w-[500px] text-[15px] leading-relaxed text-lt-cream3">
        De estatísticas profundas a IA personalizada
      </p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {features.map((f, i) => (
          <button
            key={i}
            onClick={() => onFeatureClick(i)}
            className={cn(
              "group relative rounded-2xl border p-6 text-left transition-all",
              activeFeature === i
                ? "border-lt-gold-border bg-lt-gold-bg"
                : "border-lt-border bg-lt-bg2 hover:border-lt-cream3/20"
            )}
          >
            <span className="mb-2 block font-serif text-[24px] text-lt-gold/70 transition-colors group-hover:text-lt-gold">
              {f.num}
            </span>
            <h3 className="mb-1.5 text-[15px] font-medium text-foreground">{f.fullName}</h3>
            <p className="mb-3 text-[13px] leading-relaxed text-lt-cream3">{f.desc}</p>
            <span className={cn("rounded-full px-2.5 py-1 text-[9px] font-medium tracking-wider", badgeClass[f.badge])}>
              {badgeLabel[f.badge]}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FeaturesGrid;
